import { useCallback } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useDeviceSelector, useGameConfigurationSelector } from 'js/store/hooks';

import { useGetGameConfig } from './useGetGameConfig';

export const useGetLaunchMethod = () => {
    const getGameConfig = useGetGameConfig();
    const gameTypes = useGameConfigurationSelector(prop('gameTypes'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return useCallback(({ gameCode }: { gameCode: string }): string => {
        const gameConfig = getGameConfig(gameCode);
        const gameType = isDesktop ? gameConfig?.desktopGameType : gameConfig?.mobileGameType;
        const provider = gameTypes.find(item => item.name === gameType);
        const platformMethod = isDesktop
            ? provider?.desktop && provider?.launchMethodDesktop
            : provider?.mobile && provider?.launchMethodMobile;

        if (!platformMethod) {
            log('error', `${gameConfig?.desktopGameType} game type or platform open method for it are not configured in admin area`);

            return '';
        }

        return platformMethod;
    }, [isDesktop, gameTypes, getGameConfig]);
};

